import BizarreTerms from './BizarreTerms';
import Coinsurance from './Coinsurance';
import Copay from './Copay';
import DeductibleFamilyNonZero from './DeductibleFamilyNonZero';
import DeductibleIndividualNonZero from './DeductibleIndividualNonZero';
import DeductibleIndividualZero from './DeductibleIndividualZero';
import ExplanationPlanTypeHmo from './ExplanationPlanTypeHmo';
import ExplanationPlanTypePpo from './ExplanationPlanTypePpo';
import Farewell from './Farewell';
import Greeting from './Greeting';
import OutOfPocketMax from './OutOfPocketMax';
import Overview from './Overview';
import PreventativeCarePaysOff from './PreventativeCarePaysOff';

export default [
  Greeting,
  Overview,
  ExplanationPlanTypePpo,
  ExplanationPlanTypeHmo,
  PreventativeCarePaysOff,
  BizarreTerms,
  DeductibleIndividualNonZero,
  DeductibleIndividualZero,
  DeductibleFamilyNonZero,
  Copay,
  Coinsurance,
  OutOfPocketMax,
  Farewell,
];
